<div class="contact-pension-preview" *ngIf="contactPreviewModel">

  <div
    *ngIf="contactPreviewModel.products.length > 0 && contactPreviewModel.totalEstimatedPensionAmount > 0; else emptyResults">

    <header *ngIf="showContactHeader">
      Aperçu des produits pension pour {{ contactPreviewModel.insuredContactName }}
    </header>

    <div class="progression" *ngIf="showProgression">
      <cf-pension-reserve-preview [model]="contactPreviewModel"
                                  [showText]="showProgressionText"
                                  [showBar]="showProgressionBar"
      ></cf-pension-reserve-preview>
    </div>

    <div class="pies" *ngIf="showCharts">
      <cf-pension-reserve-charts [model]="contactPreviewModel"
                                 [showCharts]="true"
                                 [showLegend]="showChartsLegend"
                                 [showLegalStrings]="showChartsLegalStrings"
      ></cf-pension-reserve-charts>
    </div>

  </div>

  <ng-template #emptyResults>
    <p>
      Nous ne disposons pas encore des informations nécessaires pour pouvoir vous proposer l'aperçu de ces produits
      pension.
      Dès que les compagnies nous auront communiqué les chiffres, ils apparaitront ici.
    </p>
  </ng-template>

</div>
